import clsx from "clsx"
import { useAuth } from "../../../modules/auth"

import { useEffect, useState } from "react"
import { useLazyReadMultipleQuery } from "../../../framework/services/data/tableDataApi"
import { FieldFilterType } from "../../../framework/base/types"

interface IFullname {
    name?: string,
    createdOn?: Date
}

export const useGetFullName = () => {
    const { user, siteId } = useAuth()
    const [getRecords] = useLazyReadMultipleQuery()
    const [records, setRecords] = useState<IFullname[]>([])

    useEffect(() => {
        if (!user?.contactId)
            return;

        getFullname()
        // eslint-disable-next-line
    }, [user])

    const getFullname = (): Promise<IFullname[]> => {
        if (!user?.contactId) {
            return Promise.reject('User contact not found.')
        }

        return getRecords({
            userId: user?.contactId || '',
            portalId: siteId || '',
            tableId: "contact",
            fieldList: ["fullname"],
            filters: [{
                group: 0, filters: [
                    { field: "contactid", type: FieldFilterType.Const, value: user.contactId }]
            }]
        })
            .unwrap()
            .then((data) => {
                const records = data.records.map<IFullname>(p => ({
                    name: p["fullname"]
                }))

                setRecords(records)
                return Promise.resolve(records);
            })
    }

    return { data: records }
}

export const SiteTitle = ({ className }: { className?: string }) => {
    const { data } = useGetFullName()
    const name = data?.[0]?.name
    const caption = `Welcome ${name || ''}`

    return <div className={clsx(className)}>
        <div className='d-flex align-items-center '>
            <p className='fs-2 m-0 text-light opacity-75 fw-light ls-1'>{caption}</p>
        </div>
    </div>
}